var zh_cn = {
	login_title: "证通云喇叭管理后台",
	login_ckcode: "验证码",
	login_button: "登录",
	login_account: '请输入账号',
	login_password: '请输入密码',
	reset_password: '重置密码',
	new_password: '新密码',
	sure_password: '确认密码',
	password_error: "密码不能为空",
	password_error_2: "两次输入不一致",
	password_error_3: "密码必须8位以上，包括大写字母、小写字母、数字和特殊符号",
	app_sure: '确 定',
	app_cancel: '取 消',
	app_comment: '深圳市证通电子股份有限公司 © 1993-2023 版权所有 粤ICP备12035887号',

	app_sign_out: "退出登录",
	app_sign_out_message: "确定退出登录?",
	app_all_total: '总播报数量',
	app_yesterday_total: "昨日播报数量",
	app_strokes: "笔",
	app_units: "台",
	app_device_total: '设备总数',
	app_yesterday_active: "昨日活跃设备",
	app_start_time: "开始日期",
	app_end_time: "结束日期",
	app_device_equi: "设备统计",
	app_broad_statis: "播报统计",
	app_active: '活跃',
	app_off_line: "离线",
	app_un_init: "未初始化",
	app_success: '成功',
	app_pushed: "已推送",
	app_device_ofline: '设备离线',
	app_failed: "失败",
	app_day: "天",
	app_hour: "小时",
	app_minute: '分钟',
	app_second: '秒',
	app_millisecond: "毫秒",

	app_bind: "绑 定",
	app_unbind: '解绑',
	add_selected: "添加已选",
	app_batch_import: "批量导入",
	app_bind_all: '批量绑定',
	app_unbind_selected: "解绑已选",
	add_all: "添加全部",
	app_select: '请选择',
	app_blur: "模糊",
	app_search: "搜索",
	app_delete_select: "删除已选",
	app_delete_all: "删除全部",
	app_delete_question: "确定删除数据?",
	app_delete_question_2: "确定删除这些数据?",
	app_delete_association: "确定删除关联?",
	app_range_error: "超始范围不能大于结束范围",
	app_operation: '操作',
	app_operate: '操作',
	app_detail: '详情',
	app_delete: "删除",
	app_move: "移动",
	app_nums: '数量',
	app_content: '内容',
	app_not_update: "未更新",
	app_update: "已更新",
	app_sure_unbind: '确定解除绑定?',
	app_sure_unbind_2: '确定解除这些绑定?',
	app_import_message: "上传填写好的模板",
	app_import_sure: "下载导入模板，批量填写信息",
	app_upload_template: "上传模板",

	app_select_sn: "搜索SN",
	app_select_name: "搜索名称",

	app_add_task: "添加任务",
	app_edit_task: "编辑任务",
	app_task_name: "任务名称",
	app_task_statement: "任务说明",
	app_bottom_pack: "底包升级任务",
	app_bottom_bag: "底包版本",
	app_upgrade_conditions: "升级条件",
	app_firmware_version: "固件版本",
	app_file: '文件',

	menu: {
		home: "首页",
		device_management: "设备管理",
		device_detail: "设备详情",
		merchant_management: "商户管理",
		merchant_detail: "商户详情",
		channel_vendor_management: "渠道商管理",
		channel_vendor_detail: "渠道商详情",
		personal_information: "个人信息",
		platform_configuration: "平台配置",
		model_management: "产品管理",
		account_management: "渠道商账号管理",
		parameter_management: "参数管理",
		developer_management: "开发者管理",
		upgrade_management: "升级管理",
		import_task_management: "导入任务管理",
		device_assistant: "设备助手",
		task_details: "任务详情",
		subtask_details: "子任务详情",
		login: "登录",
		Marketing: "营销广告",
		Adv: "广告审核",
		AdvList: "广告列表",
		deviceList: "设备列表",
		LanguageList: "语料列表",
		mchtList: "商户列表",
		repair: "寄修列表",




	},



	terminal: {
		Match: '电信卡匹配',
		MatchList: '匹配列表',
		matchName: '名称',
		match_num: '数量',
		match_status: '状态',
		match_createTime: '导入时间',
		match_updateTime: '完成时间',
		match_s: '已完成',
		match_e: '未完成',
		add_device: '添加设备',
		edit_device: "编辑设备",
		import_btn: '导入设备',
		pro_import: "产线导入",
		move_device: "设备迁移",
		export_device: "导出设备",
		modify_triplet: "修改三元组",
		app_distributor: '渠道商',
		device_status: "设备状态",
		network_signal: "网格信号",
		sn_or_name: "SN或名称",
		device_sn: "设备SN",
		device_name: '设备名称',
		device_type: '设备类型',
		device_key: "设备密钥",
		device_no: '设备编号',
		device_id: '设备ID',
		device_model: '设备型号',
		device_model_2: "产品型号",
		search_device: "搜索设备",
		bound_merchant: "绑定商户",
		unbound_merchant: "未绑定",
		device_ip_address: "设备IP地址",
		last_online: "上次在线时间",
		last_offline: "上次离线时间",
		dynamic_key: "动态密钥",
		volume: "音量",
		user_manual: "用户手动设置",
		network_type: "网络类型",
		platform: "平台",
		default_platform: "默认平台",
		aliyun: "阿里云",
		ba_add_device: "批量添加设备",
		prefix: "前缀",
		start_to_end: "起始~结束号段",
		order_number: "订单号",
		sure_unbind: "确定解绑设备",
		sure_unbind_2: "确定解绑设备?",
		sure_unbind_3: "确定解绑这些设备?",
		sure_delete_device: "确定删除全部设备?",
		device_detail: "设备详情",
		device_addtime: "设备添加时间",
		device_acttime: "设备激活时间",
		device_list: "设备列表",
		binding_device: "绑定设备",
		offline_time: '离线时长',
		current_network: "当前网络",
		internet_signal: "网络信号",
		device_power: "设备电量",
		hardware_version: "硬件版本",
		wifi_version: "WiFi固件版本",
		GPRS_system_version: "GPRS系统版本",
		GPRS_firmware_version: "GPRS固件版本",
		user_audio_version: "用户音频版本",
		longitude: "经度",
		latitude: "纬度",

		merchant_add_time: "商户添加时间",
		app_contactPhone: '联系电话',
		sub_organization: "所属机构",
		broad_num: "播报数量",
		cumulative_broadcast: "累计播报",
		test_broadcast: "测试播报",
		broadcast_record: "播报记录",
		export_records: "导出记录",
		serial_number: "流水号",
		branch_store: "分店",
		broadcast_state: "播报状态",
		broadcast_template: "播报模板",
		date_filter: "日期筛选",
		app_amount: "金额",
		broadcast_time: "播报时间",
		response_time: "响应时间",
		broadcast_time_consuming: "播报耗时",
		online_offline_records: "上下线记录",
		add_device_task: "添加设备至任务",
		bound_device_num: "绑定设备数量",
		device_SN_Name: "设备SN / 名称",
		binding_state: "绑定状态",
		risk_name: '配置名称',
		risk_content: '配置内容',
		push_stauts: "推送状态",
		export_config: "导出配置",








		ztgxsj: '状态更新时间',
		import_title: '导入设备信息',
		xqwj: '选取文件',
		qrdr: '确认导入',
		import_muban: '下载导入模板',
		notify_title: '导入结果提示',
		delete_tips: '此操作将永久删除该设备, 是否继续',
		deletes_tips: '此操作将永久删除所选设备, 是否继续?',
		empty_tips: '请选择要删除的设备',
		/*20170731新加*/
		excel_tips: '只能上传Excel文件，且不超过10M',



		up_smid: "升级支付宝smid",
		smid: "支付宝smid",
		isShare: "是否千里传音",
		yes: "是",
		no: "否",
		Binding_failure: "绑定失败",


	},
	merchant: {
		merchant_add: "添加商户",
		export_merchant: "导出商户",

		store_name: "商店名称",
		merchant_id: "商户ID",
		merchant_name: "商户名称",
		merchant_num: "商户号",
		merchant_can_num: "商户渠道号",
		merchant_tel: "商户电话",
		merchant_pla: "00=收银宝  01=融合支付  02=其他",
		merchant_equ: "添加设备至商户",
		merchant_numbers: "商户数量",
		edit_channel: "编辑渠道商",

		edit_merchant: "编辑商户",
		import_merchant: "导入商户",
		download_merchant_message: "下载商户导入模板，批量填写商户信息",
		upload_merchant_device: "上传填写好的渠道商模板",
		branch_management: "分店管理",
		message_num: "消息数",
		all_collection: "累计收款",
		branch_number: "分店号",
		add_branch: "添加分店",
		edit_branch: "编辑分店",
		branch_name: "分店名称",
		add_vendor: "添加渠道商",
		vendor_name: "渠道商名称",
		vendor_id: "渠道商ID",
		super_vendor: "上级渠道商",
		equipment_quantity: "设备数量",
		channel_contact: "渠道商联系人",
		contact_number: "联系人电话",
		import_devices_vendors: "导入设备至渠道商",
		move_to_channel: "移动到渠道商",
		channel_add_time: "渠道商添加时间",
		binding_user: "绑定用户",
		update_config_time: "更新配置时间",

		app_customer: "客户",
		client_name: "客户名称",
		input_client_name: "输入客户名称",
		mapping_sn: "映射SN",
		mapping_time: "映射时间",
		add_mapping: "添加映射",
		app_Platform: "平台",




	},
	model: {
		app_model: '产品名称',
		add_model: "添加产品",
		edit_model: "编辑产品",
		self_tube: "自管",
		other_manage: "他管",
	},
	deleloper: {
		add_develop: "添加开发者",
		edit_develop: "编辑开发者",
		develop_id: "开发者ID",
		develop_password: "开发者密码",
		develop_name: "开发者名称",
		develop_phone: "开发者电话",
		develop_email: "开发者邮箱",
		develop_address: "开发者地址",
		product_model: "产品型号",



	},

	select_option: {
		bind: "绑定",
		un_bond: "未绑定",
		un_bind: "解绑",
		app_enable: "启用",
		app_disabled: "停用",
		app_youyoubao: "002T",
		pending_upgrade: "待更新",
		app_updated: "已更新",
		no_data: "暂无数据",
		app_message_pushed: '已推送',
		app_notpushed: '未推送',

		app_send: "已发送",
		app_succeed: "成功",
		app_offline: "离线",
		app_error: "异常",
		no_version: "不等于任务版本",
		less_version: "小于任务版本",
		app_online: "在线",

		all_status: "所有状态",
		go_line: "上线",
		go_offline: "下线",
		app_update: "更新",

		app_agent: '渠道商',
		app_admin: "超级管理员",
		app_ordinary: "普通管理员",
		app_production: "产线管理员",

		app_task_import: "升级任务导入",
		app_device_import: "设备导入"
	},



	app_update_status: "更新状态",
	app_file_error: "文件上传达上限，请移除后再上传。",
	app_upload: '上传',
	app_clickUpdate: '点击上传',
	app_download: "下载",
	app_imp: '导入',
	app_derive: '导出',
	app_download_template: "下载模版",
	app_upload_template: "上传模板",
	app_download_device_message: "下载设备导入模板，批量填写设备信息",
	app_unupload_file: "未上传文件",
	app_upload_completed_device: "上传填写好的设备模板",
	app_delete_bind: "确定删除绑定?",
	app_delete_bind_2: "确定删除这些绑定?",
	app_choose_version: "选择版本",
	app_choose_platform: "选择平台",
	app_choose_model: "选择型号",
	app_choose_vendor: "选择渠道商",
	app_input: '请输入内容',
	app_input_num: '请输入数量',
	app_input_start: '输入数字起始段',
	app_mot: "批量修改三元组",
	app_file_invalid: "文件格式不合法",
	app_status: '状态',
	app_time: '时间',
	app_mulDel: '批量删除',
	app_mulAdd: '批量添加',
	app_add_time: "添加时间",
	app_import_result: "导入结果",
	app_description: "说明",
	app_update_time: "更新时间",
	app_no_role: "没有该角色操作",
	app_add_account: "添加账号",
	app_edit_account: "编辑账号",
	app_select_account: "搜索帐号",
	app_login_account: "登录账号",
	app_nick_name: '昵称',
	app_mobile_phone: "手机",
	app_aliyun: "阿里云Key",
	app_provider: "所属渠道商",
	app_role: "角色",
	app_telephone: "电话",
	app_enable: "启用",
	app_disabled: "停用",
	app_phone_number: "手机号",
	app_modify_data: "修改资料",
	app_change_password: "修改密码",
	app_current_password: "当前密码",
	app_new_password: "新的密码",
	app_new_password_2: "确认新密码",
	app_pasword_error: "新密码和确认密码不一致",
	app_message_pushed: '已推送',
	app_notpushed: '未推送',
	app_email: "邮箱",
	app_addres: '地址',
	app_wifi_pla: '请填写Wi-Fi固件版本，为空则不升级',
	app_wifi_pla_2: '请填写升级前的Wi-Fi版本号',
	app_gprs_pla: '请填写GPRS固件版本，为空则不升级',
	app_gprs_pla_2: '请填写升级前GPRS的版本号',
	app_audio_pla: '请填写用户音频版本，为空则不升级',
	app_wifi_version: "Wi-Fi前置版本",
	app_gprs_version: "GPRS固件版本",
	app_gprs_version_2: "GPRS前置版本",
	app_audio_version: "用户音频版本",
	app_addsubts: '添加子任务',






	app_disassociate: "取消关联",
	app_name: '名称',
	app_createTime: '创建时间',
	app_edit: '编辑',
	app_add: '添加',
	app_verify: '审核',
	app_isPass: '是否通过',
	app_pass: '通过',
	app_ban: '不通过',
	app_noInput: '未填写',
	app_banReason: '拒绝原因',
	app_filter: '筛选',
	app_prePushVerify: '待送审',
	app_preVerify: '待审核',
	app_verifyPass: '通过',
	app_verifyNotPass: '不通过',
	app_submit: '提交',
	app_other: '其他',
	app_tip: '提示',
	app_yes: '确定',
	app_no: '取消',
	app_online: '在线',
	app_offline: '离线',
	app_fileOver: '文件超过',
	app_onlyApk: '只能上传apk文件',
	app_tipViewTask: '推送成功，请在任务管理中查看推送进度',
	app_tipMkDel: '删除应用后应用市场的应用也会同步删除，确定删除？',
	app_tipAppEdit: '删除将不可恢复，确定删除？',
	app_tipVerify: '确定要提交审核吗?',
	app_rqsError: '请求出错',


	app_import_type: "导入类型",
	app_describe: "描述",
	app_total_amount: "总数量",
	app_success_number: "成功数量",
	app_failure_number: "失败数量",
	app_execution_time: "执行时间",

	app_sn_pla: "输入设备SN",
	app_task_pla: "输入任务名称",


}


export default zh_cn;
